import React from "react";
import SEO from "./SEO";

interface BlogSearchResultsSEOProps {
  query: string;
}

const BlogSearchResultsSEO: React.FC<BlogSearchResultsSEOProps> = ({
  query,
}) => {
  const title = query
    ? `Resultados de búsqueda para "${query}" | Blog de Mega Osaka`
    : "Buscar en el Blog de Mega Osaka";
  const description = query
    ? `Resultados de búsqueda para "${query}" en el blog de Mega Osaka. Encuentra artículos, consejos y novedades sobre cultura japonesa y productos.`
    : "Busca artículos, consejos y novedades en el blog de Mega Osaka.";
  const image = "/og-blog-search.jpg"; // Replace with your search OG image if available
  const url =
    typeof window !== "undefined" ? window.location.href : "/blog/search";

  const schema = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: title,
    description: description,
    url: url,
  };

  return (
    <SEO
      title={title}
      description={description}
      image={image}
      type="website"
      schema={schema}
      openGraph={{
        "og:title": title,
        "og:description": description,
        "og:image": { url: image },
        "og:url": url,
        "og:type": "website",
      }}
    />
  );
};

export default BlogSearchResultsSEO;
